import React from 'react';
import { Header, Responsive, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import SemesterEnrollment from '../../ThirdCycle/SemesterEnrollment/SemesterEnrollment';
import CourseEnrollment from '../../ThirdCycle/CourseEnrollment/CourseEnrollment';
import Grades from '../../ThirdCycle/Grades/Grades';
import GradYearEnrollment from "../../ThirdCycle/SemesterEnrollment/GradYearEnrollment";


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class PostgraduateSpecialistSp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchStudentOptions = this.fetchStudentOptions.bind(this);
    }

    componentDidMount() {
        this.fetchStudentOptions();
    }
    fetchStudentOptions() {
        axios.get('/students/specialist-study-program/')
            .then(res => {
                this.setState({
                    studentOptions: res.data.map(el => ({
                        ...el, key: el.id, value: { ...el }, text: el.firstName + ' ' + el.lastName + ' | ' + el.index
                    }))
                });
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        const panes = [
            {
                menuItem: 'Upis u semestar',
                render: () => (<Tab.Pane as={Responsive}>
                    <SemesterEnrollment specialist fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Upis u apsolventski staž',
                render: () => (<Tab.Pane as={Responsive}>
                    <GradYearEnrollment specialist fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Upis na predmet',
                render: () => (<Tab.Pane as={Responsive}>
                    <CourseEnrollment specialist fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Unos ocjene',
                render: () => (<Tab.Pane as={Responsive} >
                    <Grades specialist fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            }
        ];
        return (
            <div>
                <h1>Specijalistički studij</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Unos podataka
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/PostgraduateSpecialistSP/PostgraduateSpecialistSP.js